/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";

export function Name() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Event Name:</label>
      <span>{appointment.booking.notes}</span>
    </div>
  );
}
